import {Component, Input, OnInit} from '@angular/core';
import {FormControlName, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-multiline-text-field',
    templateUrl: './multiline-text-field.component.html',
    styleUrls: ['./multiline-text-field.component.scss'],
})
export class MultilineTextFieldComponent implements OnInit {
    @Input() label: string;
    @Input() inputName: string;
    @Input() form: UntypedFormGroup;
    @Input() isError: boolean;
    @Input() preValue: string;
    @Input() disabled = false;


    constructor() {
    }

    ngOnInit() {
        if (this.preValue && this.form && this.inputName) {
            this.form.get(this.inputName)?.setValue(this.preValue);
            if (this.disabled) {
                this.form.get(this.inputName)?.disable();
            }
        }
    }

}
